<template>
  <router-view></router-view>
</template>
<script>

// Employee Store registered in App.vue

export default {
  name: 'employee',
  data() {
    return {};
  },
};
</script>
